import { useMutation, useQueryClient } from "@tanstack/react-query";

import { enrollmentRequest } from "@/apiQueries/multisigEnrollment/multisigEnrollmentRequest";
import {
  MULTISIG_ENROLLMENT_QUERY_KEY,
  MULTISIG_ENROLLMENT_URL,
} from "@/apiQueries/multisigEnrollment/useMultisigEnrollment";

import type { EnrollmentError } from "@/helpers/enrollmentErrors";

import type { MultisigEnrollmentChallenge } from "@/types";

/** `POST /multisig/enrollment/keys`. Registers the caller's public key; returns the 5-minute Key Ownership Challenge to sign. */
export const useMultisigEnrollmentSubmitKey = () => {
  const queryClient = useQueryClient();

  return useMutation<MultisigEnrollmentChallenge, EnrollmentError, { publicKey: string }>({
    mutationFn: (vars: { publicKey: string }) =>
      enrollmentRequest<MultisigEnrollmentChallenge>(`${MULTISIG_ENROLLMENT_URL}/keys`, {
        method: "POST",
        body: JSON.stringify({ public_key: vars.publicKey }),
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: MULTISIG_ENROLLMENT_QUERY_KEY }),
  });
};
